import { useMemo } from 'react';

import cx from 'classnames';

import EditableText from 'components/shared/EditableText';
import { EBlockType, IBlock } from 'detailsv2/__blocks';
import { useTitleChangeModal } from 'hooks/useTitleChangeModal';
import i18n from 'i18n';

import { useLandingV2Context } from '../../../../context';
import { useBlockContext } from '../../Block/context';
import s from './index.module.css';

function CoverPage() {
  const { block, onUpdate, readonly = false } = useBlockContext<IBlock<EBlockType.CoverPage>>();
  const { title, subtitle } = block.data;
  const {
    config: { settings },
    data: { preparedFor, title: landingTitle, travelDates },
  } = useLandingV2Context();
  const showNavigationModal = useTitleChangeModal();
  const { textOverImages } = settings!;

  const titleValue = textOverImages ? title : landingTitle;
  const subtitleValue = useMemo(() => {
    if (textOverImages) {
      return subtitle;
    }
    const result = [];

    if (preparedFor) {
      result.push(`${i18n.t('proposal_content.prepared_for')} ${preparedFor}`);
    }

    if (travelDates) {
      result.push(travelDates);
    }

    return result.join('\n');
  }, [textOverImages, subtitle, preparedFor, travelDates, i18n.version]);

  const handleChange = (enteredValue: string, type: 'title' | 'subtitle') => {
    const obj = { ...block, data: { ...block.data, [type]: enteredValue } };

    onUpdate?.(obj);
  };

  return (
    <div
      className={cx(s.wrapper, 'custom-coverpage-wrapper')}
      onClick={() => {
        if (!textOverImages) showNavigationModal(readonly);
      }}
    >
      {(!readonly || titleValue) && (
        <div className={cx(s.title, 'custom-coverpage-title')}>
          <EditableText
            text={titleValue || ''}
            onChange={(value) => handleChange(value, 'title')}
            placeholder="Title"
            textAlignment="center"
            isReadonly={!textOverImages}
            isLineBreak
          />
        </div>
      )}
      {(!readonly || subtitleValue) && (
        <div className={cx(s.subtitle, 'custom-coverpage-subtitle')}>
          <EditableText
            text={subtitleValue || ''}
            onChange={(value) => handleChange(value, 'subtitle')}
            placeholder="Subtitle"
            textAlignment="center"
            isReadonly={!textOverImages}
            isLineBreak
          />
        </div>
      )}
    </div>
  );
}

export default CoverPage;
